<!-- <template>
  <b-card>
    <div class="mt-0">
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-primary">
              <feather-icon size="12" class="text-primary" icon="UserIcon" />
            </b-avatar>
          </span>
          <span>Today</span>
        </div>
        <div class="text-primary">{{ visitors.today.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-secondary">
              <feather-icon
                size="12"
                class="text-secondary"
                icon="CalendarIcon"
              />
            </b-avatar>
          </span>
          <span>This Week</span>
        </div>
        <div class="text-primary">{{ visitors.week.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-success">
              <feather-icon
                size="12"
                class="text-success"
                icon="CalendarIcon"
              />
            </b-avatar>
          </span>
          <span>This Month</span>
        </div>
        <div class="text-primary">{{ visitors.month.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-warning">
              <feather-icon
                size="12"
                class="text-warning"
                icon="CalendarIcon"
              />
            </b-avatar>
          </span>
          <span>This Year</span>
        </div>
        <div class="text-primary">{{ visitors.year.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-info">
              <feather-icon size="12" class="text-info" icon="TrendingUpIcon" />
            </b-avatar>
          </span>
          <span>Overall</span>
        </div>
        <div class="text-primary">{{ visitors.overall.toLocaleString() }}</div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard, BCardText, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BAvatar,
  },

  data() {
    return {
      visitors: {
        today: 0,
        week: 0,
        month: 0,
        year: 0,
        overall: 0,
      },
    }
  },

  mounted() {
    this.fetchVisitors()
  },

  methods: {
    fetchVisitors() {
      this.$http
        .get('/visitors')
        .then(({ data }) => {
          this.visitors = data
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
    },
  },
}
</script>

<style scoped>
.b-avatar {
  width: 1.5rem;
  height: 1.5rem;
}

[dir] .card-body {
  padding: 1.5rem 1.5rem 1rem 1.5rem;
 }
</style> -->

<template>
    <div class="mt-0">
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-primary">
              <feather-icon size="12" class="text-primary" icon="UserIcon" />
            </b-avatar>
          </span>
          <span>Today</span>
        </div>
        <div class="text-primary">{{ visitors.today.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-secondary">
              <feather-icon
                size="12"
                class="text-secondary"
                icon="CalendarIcon"
              />
            </b-avatar>
          </span>
          <span>This Week</span>
        </div>
        <div class="text-primary">{{ visitors.week.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-success">
              <feather-icon
                size="12"
                class="text-success"
                icon="CalendarIcon"
              />
            </b-avatar>
          </span>
          <span>This Month</span>
        </div>
        <div class="text-primary">{{ visitors.month.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-warning">
              <feather-icon
                size="12"
                class="text-warning"
                icon="CalendarIcon"
              />
            </b-avatar>
          </span>
          <span>This Year</span>
        </div>
        <div class="text-primary">{{ visitors.year.toLocaleString() }}</div>
      </div>
      <div class="mb-1 d-flex justify-content-between">
        <div>
          <span class="mr-1">
            <b-avatar rounded="sm" class="badge-light-info">
              <feather-icon size="12" class="text-info" icon="TrendingUpIcon" />
            </b-avatar>
          </span>
          <span>Overall</span>
        </div>
        <div class="text-primary">{{ visitors.overall.toLocaleString() }}</div>
      </div>
    </div>
</template>

<script>
import { BCard, BCardText, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BAvatar,
  },

  data() {
    return {
      visitors: {
        today: 0,
        week: 0,
        month: 0,
        year: 0,
        overall: 0,
      },
    }
  },

  mounted() {
    this.fetchVisitors()
  },

  methods: {
    fetchVisitors() {
      this.$http
        .get('/visitors')
        .then(({ data }) => {
          this.visitors = data
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
    },
  },
}
</script>

<style scoped>
.b-avatar {
  width: 1.5rem;
  height: 1.5rem;
}

[dir] .card-body {
  padding: 1.5rem 1.5rem 1rem 1.5rem;
 }
</style>